import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout, Column, EnhancedAutocomplete, Spinner, TextField, Tooltip, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientContactPicker } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientContactPicker/ClientContactPicker';
import { ClientPicker } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientPicker/ClientPicker';
import { useLocaleKeys } from '~/i18n';
import { useBillRecipientSelector } from './hooks/useBillRecipientSelector';
export const GetBillRecipientSelectorTID = (parentTestId)=>getTestIds(parentTestId);
export const BillRecipientSelector = (param)=>{
    let { onResolved, testId } = param;
    var _agreementOptions_find;
    const { t } = useLocaleKeys('components.billRecipientSelector');
    const { t: globalBillModalTexts } = useLocaleKeys('components.globalBillModal');
    const { BillRecipientSelectorTestIds } = useMemo(()=>GetBillRecipientSelectorTID(testId), [
        testId
    ]);
    const { clients, clientsLoading, clientsError, contactsError, hasMissingBuyer, selectedClientId, onSelectClient, onCreateClient, onRetryClients, showAgreementField, agreementOptions, selectedAgreementValue, onSelectAgreement, agreementsLoading, billTo, showNoAgreementCallout } = useBillRecipientSelector(onResolved);
    const selectedAgreementOption = (_agreementOptions_find = agreementOptions.find((option)=>option.value === selectedAgreementValue)) !== null && _agreementOptions_find !== void 0 ? _agreementOptions_find : null;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        testId: BillRecipientSelectorTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(ClientPicker, {
                clients: clients,
                isLoading: clientsLoading,
                selectedClientId: selectedClientId,
                onSelectClient: onSelectClient,
                onSelectSample: ()=>{},
                onCreateClient: onCreateClient,
                onEditClient: ()=>{},
                onRetry: onRetryClients,
                error: clientsError || undefined,
                showSampleClientOption: false,
                showEditPencil: false,
                disabled: clientsLoading,
                testId: BillRecipientSelectorTestIds.ClientPicker()
            }),
            agreementsLoading && /*#__PURE__*/ _jsx(Spinner, {
                centeredInBox: true,
                size: 40,
                centerBoxHeight: 48
            }),
            !agreementsLoading && showAgreementField && /*#__PURE__*/ _jsx(EnhancedAutocomplete, {
                bi: {
                    name: 'agreement_selector'
                },
                testId: BillRecipientSelectorTestIds.AgreementPicker(),
                size: "medium",
                options: agreementOptions,
                keyField: "value",
                labelField: "label",
                selectedOption: selectedAgreementOption,
                emptySearchText: t.emptySearchText(),
                textFieldProps: {
                    bi: {
                        name: 'agreement_selector'
                    },
                    label: t.agreementLabel(),
                    placeholder: t.agreementPlaceholder(),
                    alwaysShrinkLabel: true
                },
                applyOptionChange: (option)=>{
                    if (option != null) onSelectAgreement(option.value);
                }
            }),
            !agreementsLoading && billTo.kind === 'locked' && /*#__PURE__*/ _jsx(Tooltip, {
                title: t.lockedSignatoryTooltip(),
                placement: "top",
                children: /*#__PURE__*/ _jsx(TextField, {
                    bi: {
                        name: 'bill_to_locked'
                    },
                    testId: BillRecipientSelectorTestIds.LockedBillTo(),
                    label: t.billToLabel(),
                    value: billTo.buyerLabel,
                    error: hasMissingBuyer,
                    helperText: hasMissingBuyer ? t.missingSignatory() : undefined,
                    disabled: true,
                    size: "medium"
                })
            }),
            !agreementsLoading && billTo.kind === 'iwa' && billTo.isLoading && /*#__PURE__*/ _jsx(Spinner, {
                centeredInBox: true,
                size: 40,
                centerBoxHeight: 48
            }),
            !agreementsLoading && billTo.kind === 'iwa' && !billTo.isLoading && /*#__PURE__*/ _jsx(ClientContactPicker, {
                contacts: billTo.contacts,
                value: billTo.selectedContact,
                onChange: billTo.onSelectContact,
                onCreateContact: billTo.onCreateContact,
                label: t.billToLabel(),
                placeholder: t.billToLabel(),
                error: contactsError ? t.failedToLoadContacts() : undefined,
                testId: BillRecipientSelectorTestIds.ContactPicker()
            }),
            !agreementsLoading && billTo.kind === 'iwa' && !billTo.isLoading && showNoAgreementCallout && /*#__PURE__*/ _jsxs(Callout, {
                testId: BillRecipientSelectorTestIds.NoAgreementCallout(),
                intent: "info",
                withBorder: true,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: BillRecipientSelectorTestIds.NoAgreementCalloutTitle(),
                        variant: "paragraph1",
                        weight: "bold",
                        children: globalBillModalTexts.noAgreementCalloutTitle()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: BillRecipientSelectorTestIds.NoAgreementCalloutBody(),
                        variant: "paragraph1",
                        children: globalBillModalTexts.noAgreementCalloutBody()
                    })
                ]
            })
        ]
    });
};
